import { render } from "./BotConfig.vue?vue&type=template&id=51609201&scoped=true"
import script from "./BotConfig.vue?vue&type=script&lang=js"
export * from "./BotConfig.vue?vue&type=script&lang=js"

import "./BotConfig.vue?vue&type=style&index=0&id=51609201&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51609201"]])

export default __exports__